import React from 'react';

export const FontPreloader = () => {
  return (
    <div className='fixed bottom-0 right-0 invisible w-1 h-1 neue-text-editor'>
      <h1>
        Text
        <strong>Text</strong>
        <em>Text</em>
      </h1>
      <h2>
        Text
        <strong>Text</strong>
        <em>Text</em>
      </h2>
      <p>
        Text
        <strong>Text</strong>
        <em>Text</em>
      </p>
    </div>
  );
};
